import { useEffect, useState } from 'react';
import { Header, MembersTable, StatsPanel, Table } from '../components';
import { useMutation } from "react-query";
import routes from "../routes/routes";
import { withAuthHeader } from "../routes/authRequest";

function Dashboard() {
    const [memberInfo, setMemberInfo] = useState({})
    const mutation = useMutation(userData => withAuthHeader.post(routes.api.locations.updateProfile, 
        {id: memberInfo.id, ...userData}
        ))

    useEffect(() => {
    }, [])
    return (
        <div className="mainpanel">

            {/* <!-- pageheader --> */}
            <Header />

            <div className="contentpanel">

                <div className="row row-stat">
                    <StatsPanel icon="fa fa-dollar" value="NGN 98,102,766" yesterday="NGN 98,102,766" color="panel-success-alt" title="TOTAL EARNINGS" />
                    <StatsPanel icon="fa fa-users" value="NGN 1,102,544" yesterday="NGN 1,098,544" color="panel-primary" title="TODAY'S EARNINGS" />
                    <StatsPanel icon="fa fa-pencil" value="3,102" yesterday="3,101" color="panel-dark" title="TOTAL USERS" />
                </div>

                <h1>Members</h1>

                <MembersTable />
                {/* <Table /> */}
            </div>

        </div>
    );
}

export default Dashboard;
